import { List, ListItem, ListItemText, Typography } from "@mui/material";

import { ExpandedEcrAssignmentRow } from "api/memberPortal/reports/expandedEcrAssignment/expandedEcrAssignment.types";

const ConformanceClaimsCell = ({
  row: { conformance_claims },
}: {
  row: ExpandedEcrAssignmentRow;
}) => {
  return (
    <List sx={{ padding: "0" }}>
      {conformance_claims.map((claim: string) => (
        <ListItem key={claim}>
          {/* WARN: Custom styling from pre standardization! */}
          {/* TODO: Standardize when you come across this!  */}
          <ListItemText
            sx={{ margin: "0", typography: "caption" }}
            primary={<Typography variant="caption">{claim}</Typography>}
          />
        </ListItem>
      ))}
    </List>
  );
};

export default ConformanceClaimsCell;
